import { render, staticRenderFns } from "./customerCaseDetail.vue?vue&type=template&id=b3e768a2&scoped=true"
import script from "./customerCaseDetail.vue?vue&type=script&lang=js"
export * from "./customerCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./customerCaseDetail.vue?vue&type=style&index=0&id=b3e768a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e768a2",
  null
  
)

export default component.exports